import { buildQuoteUrl } from './quote.js';
/**
 * Shared catalog helpers: image URL map and product card template.
 */
export const images = {
    'Argonero_de_piel.webp': new URL('../img/guantes/Argonero_de_piel.webp', import.meta.url).href,
    'Argonero_de_piel_2.webp': new URL('../img/guantes/Argonero_de_piel_2.webp', import.meta.url).href,
    'Argonero_de_piel_4.webp': new URL('../img/guantes/Argonero_de_piel_4.webp', import.meta.url).href,
    'Argonero_de_piel_3.webp': new URL('../img/guantes/Argonero_de_piel_3.webp', import.meta.url).href,
    'Argonero_elastico.webp': new URL('../img/guantes/Argonero_elastico.webp', import.meta.url).href,
    'Argonero_elastico_2.webp': new URL('../img/guantes/Argonero_elastico_2.webp', import.meta.url).href,
    'Operador.webp': new URL('../img/guantes/Operador.webp', import.meta.url).href,
    'Operador_2.webp': new URL('../img/guantes/Operador_2.webp', import.meta.url).href,
    'Operador_3.webp': new URL('../img/guantes/Operador_3.webp', import.meta.url).href,
    'Operador_4.webp': new URL('../img/guantes/Operador_4.webp', import.meta.url).href,
    'Soldador_gris.webp': new URL('../img/guantes/Soldador_gris.webp', import.meta.url).href,
    'Soldador_gris_2.webp': new URL('../img/guantes/Soldador_gris_2.webp', import.meta.url).href,
    'Soldador_gris_3.webp': new URL('../img/guantes/Soldador_gris_3.webp', import.meta.url).href,
    'Soldador_gris_par.webp': new URL('../img/guantes/Soldador_gris_par.webp', import.meta.url).href,
    'Soldador_azul.webp': new URL('../img/guantes/Soldador_azul.webp', import.meta.url).href,
    'Soldador_azul_2.webp': new URL('../img/guantes/Soldador_azul_2.webp', import.meta.url).href,
    'Soldador_azul_3.webp': new URL('../img/guantes/Soldador_azul_3.webp', import.meta.url).href,
    'Soldador_azul_par.webp': new URL('../img/guantes/Soldador_azul_par.webp', import.meta.url).href,
    'Soldador_rojo.webp': new URL('../img/guantes/Soldador_rojo.webp', import.meta.url).href,
    'Soldador_rojo_2.webp': new URL('../img/guantes/Soldador_rojo_2.webp', import.meta.url).href,
    'Soldador_rojo_3.webp': new URL('../img/guantes/Soldador_rojo_3.webp', import.meta.url).href,
    'Soldador_rojo_par.webp': new URL('../img/guantes/Soldador_rojo_par.webp', import.meta.url).href,
};


export const categoryNames = { soldadura: 'Soldadura', argon: 'Argón', 'trabajo-general': 'Trabajo general' };
export const swatches = { azul: '#224575', rojo: '#943329', gris: '#8a8380', 'amarillo natural': '#d19a3a' };
export function productUrlFor(product) { return './producto.html?ver=' + encodeURIComponent(product.name); }
export function swatchFor(product) {
    var color = product.colors && product.colors.values[0];
    return swatches[color] ? '<span class="color-dot" style="--swatch:' + swatches[color] + '" title="' + color + '"></span>' : '';
}
export function elementToCard(product, index) {
    var productUrl = productUrlFor(product);
    var photo = product.imgs.find(function (name) { return name.includes('_par'); }) || product.imgs[0];
    var hoverPhoto = product.imgs.find(function (name) { return name !== photo; });
    var position = typeof index === 'number' ? '<span class="card-index">' + String(index + 1).padStart(2, '0') + '</span>' : '';
    var facts = [
        ['Material', product.specs.Material],
        ['Longitud', product.specs.Longitud || product.specs.Largo],
        [product.specs.Costuras ? 'Costuras' : 'Ajuste', product.specs.Costuras || product.specs.Ajuste]
    ];
    return `
    <article class="catalog-card wow" data-category="${product.category}">
        <div class="card">
            <a href="${productUrl}" class="card-image-link" aria-label="Ver ficha de ${product.name}">
                <span class="card-category">${categoryNames[product.category]}</span>
                <img src="${images[photo]}" alt="${product.name}, vista del producto" loading="lazy" decoding="async" width="400" height="280">
                ${hoverPhoto ? '<img class="card-hover-image" src="' + images[hoverPhoto] + '" alt="" loading="lazy" decoding="async" width="400" height="280">' : ''}
                ${position}
            </a>
            <div class="card-content">
                <h3 class="card-product-title">${swatchFor(product)}<a href="${productUrl}">${product.name}</a></h3>
                <dl class="card-facts">${facts.map(function ([label, value]) { return '<div><dt>' + label + '</dt><dd>' + value + '</dd></div>'; }).join('')}</dl>
                ${product.specs.Refuerzo ? '<p class="variant-note">' + product.specs.Refuerzo + '</p>' : ''}
                <div class="card-actions">
                    <a href="${productUrl}" class="text-link" aria-label="Ver ficha de ${product.name}">Ver ficha ↗</a>
                    <a href="${buildQuoteUrl(product.name)}" class="button is-warning" target="_blank" rel="noopener noreferrer" aria-label="Cotizar ${product.name} por WhatsApp">Cotizar ↗</a>
                </div>
            </div>
        </div>
    </article>`;
}

export const compareRows = ['Costuras', 'Refuerzo', 'Forro', 'Longitud'];
export function soldadorTable(products, current) {
    var models = products.filter(function (glove) { return glove.category === 'soldadura'; });
    var head = models.map(function (glove) {
        var name = glove === current ? glove.name + ' <small>(este modelo)</small>' : '<a href="' + productUrlFor(glove) + '">' + glove.name + '</a>';
        return '<th scope="col"' + (glove === current ? ' aria-current="page"' : '') + '>' + swatchFor(glove) + name + '</th>';
    }).join('');
    var rows = compareRows.map(function (key) {
        return '<tr><th scope="row">' + key + '</th>' + models.map(function (glove) {
            var value = glove.specs[key];
            return '<td' + (value ? '' : ' class="is-empty"') + '>' + (value || 'No especificado') + '</td>';
        }).join('') + '</tr>';
    }).join('');
    var actions = '<tr class="compare-actions"><th scope="row">Cotizar</th>' + models.map(function (glove) {
        return '<td><a href="' + buildQuoteUrl(glove.name) + '" class="button is-warning" target="_blank" rel="noopener noreferrer" aria-label="Cotizar ' + glove.name + ' por WhatsApp">Cotizar ↗</a></td>';
    }).join('') + '</tr>';
    return '<div class="compare-scroll"><table class="compare-table"><caption class="is-sr-only">Comparación de los modelos de soldador</caption><thead><tr><th scope="col"><span class="is-sr-only">Dato</span></th>' + head + '</tr></thead><tbody>' + rows + actions + '</tbody></table></div>';
}
